/** Showmore respects viewport (lazy loading) and focus (focus point) */
(function() {
  'use strict';
  function Showmore (el) {
    var self = this;
    this.el = el; // showmore container
    this.visibleItems = 0; // count visible items

    // try to find a unique storage identifier
    this.store = null;
    let params = new URLSearchParams(window.location.search);
    function findClosest(el, s) {
      var dest = null;
      do {
        dest = el.querySelector(s);
        if (dest) return dest;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    }
    // generate store name
    this.store = window.location.pathname;
    let id = el.id;
    if (id) {
      this.store = this.store + '/' + id;
    }
    let t, tab = findClosest(this.el, 'ul.tabsheets > li.tabsheet-item > .sheet-header');
    if (tab) {
      t = tab.innerHTML;
      this.store = this.store + '/#' + t;
    }
    let q = params.get("tx_solr[q]");
    if (q) {
      this.store = this.store + '/' + q;
    }
    // get initialization values
    this.step = parseInt(el.getAttribute('data-step'), 10); // load more step
    if (isNaN(this.step)) {
      this.step = 10; // default if no data-step is defined
    }

    // list works with showmore-trigger button
    this.btn = this.el.lastElementChild; // show more button
    if (this.btn) {
      if (this.btn.dataset.type != 'showmore-trigger') {
        this.btn = this.btn.querySelector("[data-type='showmore-trigger']");
      }
    }
    if (this.btn) {
      this.els = this.el.children; // show more items
      this.len = this.els.length-1; // item counter
      if (this.exists()) {
        // activate button to show more
        this.btn.addEventListener("click", function (event) {
          document.activeElement.blur();
          self.more();
          event.preventDefault();
          event.stopPropagation();
        });
        this.btn.classList.remove('hidden');
      } else {
        // hide button if there are no hidden items to show
        this.btn.classList.add('hidden');
      }
    }

    // list works with input filter field
    this.input = null; // filter input field
    //find contentElement div
    let node = this.el;
    while (node && (node.id == '' || node.id.charAt(0) != 'c')) {
      node = node.parentNode;
    }
    if (node && node.id != '' && node.id.charAt(0) == 'c') {
      // search for filter input
      let searchbox = node.querySelector("[data-type='showmore-searchbox']");
      // add test input
      if (!searchbox && this.el.dataset && this.el.dataset.options && this.el.dataset.options.indexOf('searchbox') !== -1) {
        searchbox = document.createElement('div');
        searchbox.dataset.type = 'showmore-searchbox';
        searchbox.className = 'searchbox list-search-live';
        node.insertBefore(searchbox, node.firstChild);
      }
      if (searchbox) {
        let searchinputbox = document.createElement('span');
        this.input = document.createElement('input');
        this.input.className = 'searchinput';
        this.input.type = 'text';
        searchinputbox.appendChild(this.input);
        searchbox.appendChild(searchinputbox);
      }
      if (this.input) {
        this.input.addEventListener('keyup', function (event) {
          self.filter();
        });
        this.input.addEventListener('input', function (event) {
          self.filter();
        });
        this.input.value = sessionStorage.getItem('filter-' + this.store);
        this.filter();
      }
    }
  }
  Showmore.prototype = {
    // check if hidden items exists
    exists: function () {
      let c = sessionStorage.getItem('showmore-' + this.store) || 0; // load showmore storage value
      for (let i = 0; i < this.len; i++) {
        if (i < c) {
          // restore showmore storage state
          this.els[i].classList.remove('hidden');
        } else if (this.els[i].classList.contains('hidden')) {
          // found first hidden item
          this.visibleItems = i;
          sessionStorage.setItem('showmore-' + this.store, this.visibleItems); // init showmore storage value
          return true;
        }
      }
      return false;
    },
    // show more items
    more: function () {
      let c = 0;
      this.btn.classList.add('hidden');
      for (let i = 0; i < this.len; i++) {
        // show more hidden items until counter has size of step
        if (this.els[i].classList.contains('hidden') && (this.els[i].style.display != 'none')) {
          if (c < this.step) {
            this.els[i].classList.remove('hidden');
            // Set focus to first newly displayed list item. BAEK-
            if (c === 0) {
              let anchor = this.els[i].querySelector('a');
              if (anchor) {
                anchor.focus();
              }
            }
            c++;
          } else {
            this.btn.classList.remove('hidden');
            break;
          }
        }
      }
      this.visibleItems = this.visibleItems + this.step;
      sessionStorage.setItem('showmore-' + this.store, this.visibleItems); // set showmore storage value
    },
    // filter items
    filter: function () {
      let searchString = this.input.value.toLowerCase();
      sessionStorage.setItem('filter-' + this.store, searchString);
      let c = 0;
      this.btn.classList.add('hidden');
      for (let i = 0; i < this.len; i++) {
        if (this.els[i].textContent.toLowerCase().indexOf(searchString) > -1) {
          c++;
          this.els[i].style.display = '';
        } else {
          this.els[i].style.display = 'none';
        }
        if (c <= this.visibleItems) {
          this.els[i].classList.remove('hidden');
        } else {
          this.els[i].classList.add('hidden');
          this.btn.classList.remove('hidden');
        }
      }
    }
  };

  // get all showmore container
  var i, els = document.querySelectorAll("[data-type='showmore']"), len = els.length;
  for (i = 0; i < len; i++) {
    // add an onclick eventlistener to loadmore button
    // that handles the remove of hidden class of load more items
    // this doesn't break viewport (lazy loading) and focus (focus point)
    new Showmore(els[i]);
  }

  // expose constructor globally
  window.Showmore = Showmore;

})();
